/**
 * Yoast SEO payload (`yoast_head_json`) that WordPress attaches to page/CPT REST
 * responses. The legacy expworldholdings.com site is SEO-tuned via Yoast; the
 * AGNT pages carry that metadata over so we don't lose the rankings that work.
 *
 * Modelled leniently (every field optional, `.passthrough()` keeps anything we
 * don't map) so Yoast version/field drift can't break a page. URLs (`canonical`,
 * `og_url`, schema `@id`s) reflect the host the API was generated on, so they
 * follow `AGNT_INC_CONTENT_PAGE_API_URL` across environments.
 */

import { z } from 'zod';

const YoastImageSchema = z.object({
  url: z.string(),
  width: z.coerce.number().optional(),
  height: z.coerce.number().optional(),
});

export const YoastHeadJsonSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  robots: z.record(z.string(), z.string()).optional(),
  canonical: z.string().optional(),
  og_type: z.string().optional(),
  og_url: z.string().optional(),
  og_image: z.array(YoastImageSchema).optional(),
  schema: z.record(z.string(), z.unknown()).optional(),
});

export type YoastHeadJson = z.infer<typeof YoastHeadJsonSchema>;
